import { Component, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { ApiService } from 'src/app/Services/api.service';

@Component({
    selector: 'app-edit-infringement-type',
    templateUrl: './edit-infringement-type.component.html',
    styleUrls: ['./edit-infringement-type.component.scss'],
    standalone: false
})
export class EditInfringementTypeComponent extends ModelEditor {

  constructor(
    private apiService: ApiService,
    public route: ActivatedRoute,
    private injector: Injector,
    private toastr: ToastrService
  ) {
    super('enforcement/infringement-types', injector);
  }

  public DefaultModel() {
    return {
      Name: '',
      Description: '',
      BaseFine: 0,
      IsActive: true,
      AppealEligible: true,
      Escalations: []
    };
  }

  public AfterModelLoaded(): void {
    if (!this.FormLoaded) {
      return;
    }
    if (!this.escalations?.length) {
      this.addEscalation();
    }
  }

  public BeforeSave(): boolean | void {
    return true;
  }

  public Validators() {
    return {
      Name: { required: true },
      BaseFine: { required: true, min: 0 },
      Escalations: {}
    };
  }

  public get escalations(): UntypedFormArray {
    return this.Form.get('Escalations') as UntypedFormArray;
  }

  public addEscalation(): void {
    if (!this.escalations) {
      return;
    }
    const sequence = this.escalations.length + 1;
    this.escalations.push(new UntypedFormGroup({
      Id: new UntypedFormControl(null),
      Sequence: new UntypedFormControl(sequence, Validators.required),
      DaysAfterIssuance: new UntypedFormControl(0, [Validators.required, Validators.min(0)]),
      AdditionalFee: new UntypedFormControl(0, [Validators.required]),
      Description: new UntypedFormControl('')
    }));
  }

  public removeEscalation(index: number): void {
    if (!this.escalations || this.escalations.length <= 1) {
      return;
    }
    this.escalations.removeAt(index);
  }
}


